module.exports = __webpack_public_path__ + "img/the_old_nightguards_new_jobs.9ad944bb.jpg";